<script>
import breakpoints from '@/libs/breakpoints'
import utmTracking from '@/mixins/utm-tracking'
import Banner from './Banner'
import categorySets from '@/mixins/category-set'

export default {
  components: { Banner },
  render: function (createElement) {
    return createElement('div', {}, [
      createElement(Banner, {
        props: {
          slides: this.slides
        }
      })
    ])
  },
  mixins: [utmTracking, categorySets],
  data: function () {
    return {
      slides: []
    }
  },
  mounted: function () {
    this.getSlides()
  },
  computed: {
    isMobile: function () {
      return breakpoints.isMobile()
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    }
  },
  methods: {
    reset: function () {
      this.slides = []
    },
    getSlides: async function () {
      this.reset()
      await this.getCategoryObj()
      const catSets = await this.getCategorySetsForCategoryPage(this.appName, this.categoryID)
      const catBtns = await this.getBannerButtonsForCategoryPage(this.appName, this.categoryID)

      let btnCheck = false
      for (let i = 0; i < catSets.length; i++) {
        // Initialize JSON
        const emp = {}
        emp.content = {}
        emp.content.link = {}
        emp.content.button = {}

        emp.id = catSets[i].id
        emp.title = {
          title: catSets[i].title,
          image: catSets[i].title_image,
          imageAltText: catSets[i].title_image_alt_text
        }
        emp.description = catSets[i].description
        emp.background = {
          image: catSets[i].background_image
        }
        for (let j = 0; j < catBtns.length; j++) {
          if (catSets[i].id === parseInt(catBtns[j].banner_id)) {
            if (!btnCheck) {
              emp.content.link.show = true
              emp.content.link.text = catBtns[j].text
              emp.content.link.url = catBtns[j].link
              emp.content.link.paramName = catBtns[j].option_name
              emp.content.link.paramValue = catBtns[j].option_value
              btnCheck = true
            } else {
              emp.content.button.show = true
              emp.content.button.text = catBtns[j].text
              emp.content.button.url = catBtns[j].link
              emp.content.button.paramName = catBtns[j].option_name
              emp.content.button.paramValue = catBtns[j].option_value
              btnCheck = false
            }
          }
        }
        btnCheck = false
        this.slides.push(emp)
      }
    },
    getCategoryObj: async function () {
      if (this.$route.params.category && this.$route.params.category.length > 0) {
        this.category = this.$route.params.category
      } else {
        this.category = this.$route.query.category
      }
      try {
        this.categoryObj = await this.getShowBannerForCategoryFlag(this.category)
        if (this.categoryObj === null) {
          if (this.$route.path === '/home') {
            this.showBanners = true
          } else {
            this.showBanners = false
          }
        } else {
          this.categoryID = this.categoryObj.id
          this.showBanners = this.categoryObj.showBanner
        }
      } catch (error) {
        console.error(error)
      }
    },
    directToWebinars: function () {
      window.open('https://www.engineering.com/Webinars.aspx', '_system')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

::v-deep .slide20 {
  .title {
    font-size: 2rem;
    text-align: center;
    line-height: 2.6rem;
  }
  .text {
    border: 3px solid #722786;
    border-radius: 10px;
    padding: 1.5rem 1rem 0 1rem;
    width: 650px;
    margin: auto;
    top: -20px;
  }
  .description:before {
    content: none;
  }
  .description {
    width: 100%;
    font-size: 1.3rem;
    padding: 0px 6rem;
    text-align: center;
    color: #a5a4a7;
  }
  .link {
    top: 20px;
    position: relative;
    margin: 1.5rem auto 0 auto;
  }
  .text-container {
    margin: 0 auto;
  }

  @media (max-width: 665px) {
    .text {
      width: 500px;
      top: 0px;
    }
    .title {
      font-size: 2rem;
      line-height: 2.2rem;
    }
    .description {
      padding: 0px 1.2rem;
      line-height: 1.5rem;
    }
  }
  @media (max-width: 515px) {
    .text {
      width: 350px;
      top: -12px;
    }
    .title {
      font-size: 1.5rem;
      line-height: 2.2rem;
    }
    .description {
      padding: 0px 1rem;
      line-height: 1.5rem;
    }
    .link {
      top: 16px;
      margin-top: 1rem;
    }
  }
  @media (max-width: 400px) {
    .text {
      width: 300px;
      padding: 1.5rem 0.7rem 0 0.7rem;
    }
    .title {
      font-size: 1.3rem;
    }
    .description {
      font-size: 1.1rem;
    }
  }
}

@include mobile {
  ::v-deep .slide16 {
    .title {
      font-size: 2.4rem;
      line-height: 2.8rem;
      padding-bottom: 1rem;
    }

    .description {
      width: 100%;
      padding-top: 1.2rem;
    }

    .link-container a {
      margin-top: 1.2rem;
    }
  }
}

</style>
